/** SessionStorage key for one-shot labor messages when leaving Kitting pick (same pattern as Assembly). */
export const KITTING_LABOR_FLASH_STORAGE_KEY = "manufacturing.kitting.laborFlash";
